module.exports = __webpack_public_path__ + "img/about1-mob.bcd40836.webp";